module.exports = __webpack_public_path__ + "img/checkbox-unchecked-svgrepo-com.95b38fe1.svg";